import React from "react";
import clsx from "clsx";
import { useSetPageTitle } from "../hooks";

interface PageProps {
  children: React.ReactNode | React.ReactNode[];
  useDefaultStuff?: boolean;
}

const Page: React.FC<PageProps> = ({ children, useDefaultStuff = true }) => {
  useSetPageTitle();

  if (!useDefaultStuff) {
    return <div className="h-full">{children}</div>;
  }

  return (
    <div className={clsx(["h-full", { "px-4 py-2": useDefaultStuff }])}>
      <div className="h-full flex flex-col">
        <div className="flex-grow justify-between gap-4">{children}</div>
      </div>
    </div>
  );
};

export default Page;
